function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

document.addEventListener("submit", async function (event) {
  const form = event.target.closest?.("[data-user-menu-logout]");
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector("[data-user-menu-logout-button]");
  if (button) button.disabled = true;

  try {
    const response = await fetch(form.action, {
      method: "DELETE",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
      },
    });

    if (response.ok) {
      window.location.reload();
      return;
    }
  } finally {
    if (button) button.disabled = false;
  }
});
